/* eslint-disable no-extra-parens */
/* eslint-disable react/display-name */
import { memo, useEffect, useMemo } from 'react';
import { reduxConnect } from '../../common';
import { setCurrentPage } from '../../common/actions/taboolaActions';

const position = 'below_content'; //below_content is generally on the page

const mapStoreStateToProps = (storeState) => {
    const appState = storeState?.appState?.appState || {};
    const { enableTaboola, pageId, pageMetaData, taboolaInfo, user } = appState;
    const canonicalUrl = pageMetaData?.Canonical;
    const currentPageId = storeState?.taboola?.currentPage;
    const userIsBot = user?.IsBot;
    return {
        isEnabled: enableTaboola && !userIsBot,
        taboolaInfo,
        pageId,
        canonicalUrl,
        currentPageId
    };
};

const mapDispatchToProps = {
    setCurrentPage
};

export const TaboolaStateManager = reduxConnect(mapStoreStateToProps, mapDispatchToProps) (memo(( {
    pageId,
    taboolaInfo,
    currentPageId, 
    feedCategoryType = 'auto',
    isEnabled = true,
    canonicalUrl = 'https://www.weatherbug.com/',
    setCurrentPage
}) => {
    
    const feed = useMemo(() => {
        let feedConfig;
        if (pageId) {
            const page = taboolaInfo?.find(x => (x?.Position?.toLowerCase() === position?.toLowerCase())
                && (x?.PageId?.toLowerCase() === pageId?.toLowerCase()));
            
            feedConfig = page?.Feed;
        }

        return feedConfig ? feedConfig : 'category';
    }, [taboolaInfo, pageId]);

    const notifyNewPage = () => {
        if (pageId) {
            const notificationType = {
                notify: 'newPageLoad'
            };
            
            const pageDetail = {
                url: canonicalUrl
            };

            pageDetail[feed] = feedCategoryType;
            window._taboola = window._taboola || [];
            window._taboola.push(notificationType);
            window._taboola.push(pageDetail);
            setCurrentPage(pageId);
        }
    };

    useEffect(() => {
        if (isEnabled && pageId) {
            // If active route has changed, call notifyNewPage
            if (pageId !== currentPageId) {
                notifyNewPage();
            }
        }

    }, [pageId, currentPageId]);

    return null;

}));
